import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

export const PrivateRoutes = () => {
  const { islogin, sidebar = [] } = useSelector((state) => state.auth);

  const location = useLocation();
  const [path, setPath] = useState("/");

  useEffect(() => {
    if (islogin) {
      setPath(location.pathname !== "/" ? location.pathname : sidebar[0]?.link);
    }
  }, [islogin, location.pathname]);

  if (islogin && location.pathname === "/") {
    return <Navigate to={path} />;
  }
  return islogin ? <Outlet /> : <Navigate to="/login" />;
};

export const PublicRoutes = () => {
  const { islogin } = useSelector((state) => state.auth);
  return !islogin ? <Outlet /> : <Navigate to="/" />;
};
